<template>
    <div>
      <b-row>
        <b-colxx xxs="12">
          <piaf-breadcrumb/>
          <div class="separator mb-3"></div>
        </b-colxx>
      </b-row>
      <div>
      <b-card no-body>
        <b-tabs card>
          <b-tab title="ค้นหาข้อมูล Store" :active="activeTabs1" @click="activeTabs1=true; activeTabs2=false;">
            <b-card-text><br>
              <b-row>
                <b-colxx lg="2" sm="3" md="4" xs="12">
                  <div class="form-group has-float-label">
                    <v-select size="sm" v-model="fromWh" :options="fromList" style="height: 30px;"/>
                    <span>From</span>
                  </div>
                </b-colxx>
                <b-colxx lg="4" sm="4" md="4" xs="12">
                <label class="form-group has-float-label mb-4">
                    <input type="input" v-model="search" size="xs"  class="form-control" @keyup.enter="onloadData()">
                    <span>Search</span>
                  </label>
                </b-colxx>
    
                <b-colxx lg="2" sm="3" md="4" xs="12">
                <b-button size="sm" variant="info" style="float: left; margin-right:5px;" @click="onloadData()" ><i class="simple-icon-cloud-download"></i> ค้นหา Store</b-button>
               </b-colxx>
    
               </b-row>
            </b-card-text>
          </b-tab>
          <b-tab title="เพิ่ม/เเก้ไข Store" :active="activeTabs2" @click="activeTabs1=false; activeTabs2=true;">
            <b-card-text><br>
              <b-row>
              <b-colxx lg="2" sm="3" md="4" xs="12">
                <label class="form-group has-float-label mb-4">
                  <b-form-input style="width:70%; display: inline-table;" v-model="dataH['account_name']" disabled></b-form-input>
                  <b-input-group-append style="display: inline-table;">
                    <b-button variant="success default" size="sm" style="height: 35px; margin-top:-3px;" @click="onAccount()"><i class="simple-icon-magnifier" style="color: #FFF; font-weight:600;"></i></b-button>
                  </b-input-group-append>
                  <span>Account Name</span>
                </label>
    
              </b-colxx>
              <b-colxx lg="2" sm="3" md="4" xs="12">
    
    
               <div class="form-group has-float-label">
                  <v-select size="sm" v-model="dataH['province_code_sh2']" :options="provinceList" style="height: 30px;"/>
                  <span>Province</span>
                </div>
              </b-colxx>
              <b-colxx lg="1" sm="3" md="4" xs="12">
                <label class="form-group has-float-label mb-4">
                  <input type="input" v-model="dataH['store_code_sh']" size="xs"  class="form-control" :disabled="(dataH['edit'])?true:false">
                  <span>Store Code</span>
                </label>
              </b-colxx>
              <b-colxx lg="2" sm="3" md="4" xs="12">
                <label class="form-group has-float-label mb-4">
                  <input type="input" v-model="dataH['store_name']" size="xs"  class="form-control">
                  <span>Store Name</span>
                </label>
              </b-colxx>
    
              <b-colxx lg="2" sm="3" md="4" xs="12">
                <label class="form-group has-float-label mb-4">
                  <input type="input" v-model="dataH['store_name_e']" size="xs"  class="form-control">
                  <span>Store Name English</span>
                </label>
              </b-colxx>
    
              <b-colxx lg="2" sm="3" md="4" xs="12">
                <b-button size="sm" variant="info" style="float: left; margin-right:5px;" :class="{'disabled-menu' : menuRight.isreadonly == 1}" @click="onSave()"><i class="simple-icon-cloud-download"></i> บันทึก </b-button>
                <b-button size="sm" variant="warning" style="float: right; margin-right:5px;" @click="onrefresh()"> <i class="simple-icon-reload"></i> Refresh</b-button>
              </b-colxx>
            </b-row>
            </b-card-text>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
    <br>
      <b-row>
        <b-colxx xxs="12">
            <b-card class="mb-2" :style="'min-height:'+(height-290)+'px;'">
              <div class="loading" v-if="loading"></div>
               <table class="tableMain">
                  <thead>
                    <tr>
                      <th style="width:50px;">ID</th>
                      <th style="">Account</th>
                      <th style="">Province</th>
                      <th style="width:150px;">Store Code</th>
                      <th style="">Store Name</th>
                      <th style="">Store Name English</th>
                      <th style="width:100px;">Manage</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(v,i) in dataList" :key="i" @click="onModalReturn(v)">
                      <td style="text-align:center;">{{ skip+i+1 }}.</td>
                      <td>{{v.account_name }}</td>
                      <td>{{ onGetprovince(v.province_code_sh) }}</td>
                      <td style="text-align:center;"><b>{{ v.store_code_sh }}</b></td>
                      <td>{{ v.store_name }}</td>
                      <td>{{ v.store_name_e }}</td>
    
                      <td style="text-align:center;">
                        <img src="../../../assets/img2/edit.svg" width="20" title="Edit" :class="{'disabled-menu': menuRight.isreadonly == 1}" @click="onEdit(v)">&nbsp;&nbsp;&nbsp;
                        <img src="../../../assets/img2/garbage.svg" width="20" title="Delete" :class="{'disabled-menu': menuRight.isreadonly == 1}" @click="onDel(v)">
                        <!-- <b-button size="xs" variant="light" @click="onEdit(v)"> <i class="simple-icon-note"></i></b-button>
                        <b-button size="xs" variant="light" @click="onDel(v)"> <i class="simple-icon-close"></i></b-button> -->
                      </td>
                    </tr>
                  </tbody>
                </table>
            </b-card>
        </b-colxx>
    
      </b-row>
    <br><br><br>
       <div class="chat-input-container">
        <div>
          <b-row v-if="lastPage > 1">
            <b-colxx xxs="12">
              <b-pagination-nav
                v-model="page"
                @input="linkGen()"
                :number-of-pages="perPage"
                base-url="#"
                class="mt-2"
                align="center"
              >
                <template v-slot:next-text>
                  <i class="simple-icon-arrow-right"/>
                </template>
                <template v-slot:prev-text>
                  <i class="simple-icon-arrow-left"/>
                </template>
                <template v-slot:first-text>
                  <i class="simple-icon-control-start"/>
                </template>
                <template v-slot:last-text>
                  <i class="simple-icon-control-end"/>
                </template>
              </b-pagination-nav>
            </b-colxx>
          </b-row>
        </div>
      </div>
    
      <div>
        <account ref="ctaccount" v-on:ct-data-click="onModalReturn($event)"></account>
      </div>
      </div>
    </template>
    <script>
    import account from '@/components/Center/account'
    import { apiUrl, xtools } from '@/constants/config'
    import vSelect from 'vue-select'
    import moment from 'moment'
    import linq from 'js-linq'
    import $ from 'jquery';
    import { all } from 'q'
    var tabCostheight = window.innerHeight
    const $linq = function (arr) {
      return linq.from(arr)
    }
    
    export default {
      components: { vSelect,account },
      data () {
        return {
          itemSelect:{},
          activeTabs1: true,
          activeTabs2: false,
          menuRight: window.menuRight,
          skip: 0,
          height: tabCostheight,
          loading: false,
          page: 1,
          perPage: 4,
          search: '',
          from: 0,
          to: 0,
          total: 0,
          lastPage: 15,
          limitPage: 20,
          search: '',
          modalShow: false,
          fromWh: { value: 'dc_store_share_service.store_name', label: 'Store Name' },
          dataList: [],
          dataH: {},
          provinceList: [],
          fromList: [
            { value: 'dc_store_share_service.store_code_sh', label: 'Store Code' },
            { value: 'dc_store_share_service.store_name', label: 'Store Name' }
          ]
        }
      },
      methods: {
        onModalReturn (e) {
          if (e.wh == 'account') {
            this.$set(this.dataH, 'account_code', e.data.account_code)
            this.$set(this.dataH, 'account_name', e.data.account_name)
          }
          //exp_labour_name:''
        },
        onAccount () {
          this.$refs.ctaccount.onModalShow()
        },
        onGetprovince (province_code_sh) {
          let pv = $linq(this.provinceList).where(x => x.value == province_code_sh).toArray()
          console.log(this.provinceList)
          if (pv.length) {
            return pv[0].label
          } else {
            return ''
          }
        },
        async onloadProvince () { // โหลด Province
          var form = new FormData()
          form.append('from', 'province_code_sh')
          form.append('search', '')
          form.append('skip', 0)
          form.append('take', 99999)
          let data = await xtools.postServerForm('AccountingforLabor/Master/ProvinceShareService_Page_Items_Read', form)
          data.data.data.data.forEach((v, i) => {
            this.provinceList.push({ value: v.province_code_sh, label: v.province_name })
          })
          console.log(data.data.data.data)
        },
        onrefresh () {
          this.dataH = {}
        },
        async onSave () {
          if(this.menuRight.isreadonly == 1){ return; }
          this.dataH.province_code_sh = (this.dataH.province_code_sh2)?this.dataH.province_code_sh2.value:"";
          if (!this.dataH.account_code) {
            this.$notify('error filled', 'Message System', 'กรุณาเลือก Account', { duration: 5000, permanent: false })
            return false
          }
          if (!this.dataH.store_code_sh) {
            this.$notify('error filled', 'Message System', 'กรุณากรอก Store Code', { duration: 5000, permanent: false })
            return false
          }
          if (!this.dataH.store_name) {
            this.$notify('error filled', 'Message System', 'กรุณากรอก Store Name', { duration: 5000, permanent: false })
            return false
          }
           if (!this.dataH.province_code_sh) {
            this.$notify('error filled', 'Message System', 'กรุณากรอก Province', { duration: 5000, permanent: false })
            return false
          }

          if (!this.dataH.edit) {
            var duplicated = $linq(this.dataList).where(w => w.store_code_sh == this.dataH.store_code_sh).firstOrDefault()

            if (duplicated) {
              this.$notify('error filled', 'Message System', 'มี Store Code นี้ในระบบแล้ว', { duration: 5000, permanent: false })
              return false
            }
          }
    
          let wh = (this.dataH.edit) ? '1' : '0'
          //this.dataH.province_code_sh = this.dataH.province_code_sh2.value
          var data = await xtools.postServerJson('AccountingforLabor/Master/createStoreShareService?edit=' + wh, { dataH: this.dataH })
          if (data.success == true) {
            let errorLog = wh == 1?"[Edit]":"[Save]";
            xtools.onSaveActionLogs(this.$route.meta.module, this.$route.meta.nameMenu + " " + errorLog, this.dataH.store_code_sh);	
            this.$notify('success filled', 'Message System', 'Save data successfully.', { duration: 3000, permanent: false })
            this.linkGen()
          } else {
            this.$notify('error filled', 'Message System', data.error, { duration: 3000, permanent: false })
          }
        },
        onEdit (v) {
          if(this.menuRight.isreadonly == 1){ return; }
          v.edit = '1'
          let pv = $linq(this.provinceList).where(x => x.value == v.province_code_sh).firstOrDefault()
          this.dataH = v
          this.dataH.province_code_sh2 = pv
          this.activeTabs1 = false;
          this.activeTabs2 = true;
        },
        async onDel (v) { // โหลด store
          if(this.menuRight.isreadonly == 1){ return; }
          let data = await xtools.getServer('AccountingforLabor/Master/deleteStoreShareService?store_code_sh=' + v.store_code_sh)
          if (data.success == true) {
            xtools.onSaveActionLogs(this.$route.meta.module, this.$route.meta.nameMenu + " [Delete]", v.store_code_sh);
            this.$notify('success filled', 'Message System', 'Delete data successfully.', { duration: 3000, permanent: false })
          } else {
            this.$notify('error filled', 'Message System', data.error, { duration: 3000, permanent: false })
          }

          this.linkGen()
        },
        linkGen () {
          this.onloadData()
        },
        onMainexpenseother () {
          this.$refs.Ctmainexpenseother.onModalShow(this.dataList)
        },
        async onloadData () { // โหลด store
          this.loading = true
          this.dataH = {}
          this.skip = ((this.limitPage * this.page) - this.limitPage) || 0
          var form = new FormData()
          form.append('from', this.fromWh.value)
          form.append('search', this.search)
          form.append('skip', (this.limitPage * this.page) - this.limitPage)
          form.append('take', this.limitPage)
          let data = await xtools.postServerForm('AccountingforLabor/Master/storeShareService_Page_Items_Read', form)
          this.loading = false          
          this.dataList = data.data.data || []
          this.dataList.forEach((value, index) => {
            let pv = $linq(this.provinceList).where(x => x.value == value.province_code_sh).toArray()
            if (pv.length != 0) {
              value.edit = true
              value.province_code_sh2 = pv[0]
            }
          })
          this.perPage = ((data.data.total / this.limitPage) < 0) ? 1 + 1 : (data.data.total / this.limitPage) + 1
          console.log(this.perPage, 'per')
        }
      },
      mounted () {
        $(document).ready(function() {
            document.title = 'Setup Store Share Service';
        });
        this.onloadProvince()
        this.linkGen()
      }
    }
    </script>
    
    <style scoped>
    .card .card-body {
       padding-left:0.5rem;
       padding-right:0.5rem;
       padding-top:0.5rem;
       padding-bottom:0.5rem;
    }
    .tableMain {
        color: #333;
        width: 640px;
        border-collapse:
        collapse; border-spacing: 0;
        width: 100%;
    
    }
    
    .disabled-menu{
      opacity: 0.5;
      cursor: not-allowed !important;
    }
    
    
    
    </style>
    